import React, { useRef } from "react";
import { Grid, Autocomplete, TextField, Checkbox, MenuItem, Select } from "@mui/material";
import { error } from "console";
import { GENDER_CHOICE } from "../../../../constant";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import './Index.sass'
interface Props {
    error: any;
    setError: any;
    inputList: any;
    setInputList: any;
    salulationList: any;
    packageDetails: any;
    totalPrice: any;
    setTotalPrice: any;
    collectionDate: any;
    setCollectionDate: any;
    activePincodeList: any;
    pincode: any;
    setPincode: any
    setCampAreaPincode: any;
    setCampState: any;
    setCampCity: any;
    getActivePinCode: any;
    getPackageDetails: any;
    handleReset: any;
    mobileNumber: any;
    setMobileNumber: any;
    alternateMobileNumber: any;
    setAlternateMobileNumber: any;

}
const AssignDoctors: React.FC<Props> = ({
    error,
    setError,
    inputList,
    setInputList,
    salulationList,
    packageDetails,
    totalPrice,
    setTotalPrice,
    collectionDate,
    setCollectionDate,
    activePincodeList,
    pincode,
    setPincode,
    setCampAreaPincode,
    setCampState,
    setCampCity,
    getActivePinCode,
    getPackageDetails,
    handleReset,
    mobileNumber,
    setMobileNumber,
    alternateMobileNumber,
    setAlternateMobileNumber,

}) => {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const timer = useRef<any>(0);
    const handleInputChange = (e: any, index: number) => {
        const { name, value } = e.target;
        if (name === "customerName") {
            const newValue = e.target.value;

            if (!newValue.match(/[@!#^*%&<>()_+=1234567890:~`.\\$'"]/)) {
                setError("");
            } else {
                setError("Forbidden character: @!#^*%&<>()_+=1234567890:~`.\\$'\"");
            }
        }
        const list = [...inputList];
        if (name === "passport") {
            // const result = value.replace(/[^A-Z0-9]/, "");

            list[index][name] = value;
        } else {
            list[index][name] = value;
        }
        if (e.target.name === "designation") {
            const findGender = GENDER_CHOICE.filter(
                (el: any) => el.display_name === e.target.value
            );
            list[index]["customerGender"] = findGender[0]?.gender;
            list[index]["customerDesignation"] = findGender[0]?.db_name;
        }
        if (e.target.name === "dateOfBirth") {
            let today = new Date();
            let birthDate = new Date(e.target.value);
            let age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            list[index]["customerAge"] = age;
        }
        setInputList(list);
    };
    const handlePackage = (
        index: number,
        customerPackages: any,
        lastPack: any
    ) => {
        const list = [...inputList];

        list[index]["customerPackage"] = customerPackages;
        setInputList(list);

        let accumulatedPrice: any = 0;
        if (customerPackages && customerPackages.length > 0) {
            customerPackages.map((item: any) => {

                accumulatedPrice = accumulatedPrice + item.mbt_price;
                // }
            });
        }
        else if (customerPackages && customerPackages.length <= 0) {
            handleReset()
        }
        list[index]["packagePrice"] = accumulatedPrice;
        setInputList(list);
        let allPackagePrice = 0;
        inputList &&
            inputList.map((rowItem: any) => {
                console.log(rowItem, "rowItem===>rowItem")
                allPackagePrice = allPackagePrice + rowItem?.packagePrice;
            });
        console.log(allPackagePrice, "======?")
        setTotalPrice(Math.floor(allPackagePrice));
    };

    console.log(inputList, "inputList")
    return (
        <Grid container spacing={3} style={{ margin: "2rem auto" }}>
            <Grid container spacing={3} style={{ margin: "1rem" }} alignItems="flex-end">
                <h4>Assign Doctor</h4>
            </Grid>
            <Grid
                container
                direction="row"
                alignItems="flex-end"
                spacing={3}
                style={{ margin: "1rem auto", background: "#eff" }}
            >
                {inputList.map((x: any, index: number) => {
                    return (
                        <>
                            <Grid item md={1}>
                                {/* {inputList.length !== 1 && (
                                    <HighlightOffIcon
                                        style={{
                                            marginBottom: "1rem",
                                            height: "40px",
                                            width: "40px",
                                            borderRadius: "50%",
                                        }}
                                        onClick={() => handleRemoveClick(index)}
                                    />
                                )}
                                {inputList.length - 1 === index && inputList.length < 5 && (
                                    <AddCircleIcon
                                        style={{
                                            marginBottom: "1rem",
                                            height: "40px",
                                            width: "40px",
                                            borderRadius: "50%",
                                        }}
                                        onClick={handleAddClick}
                                    />
                                )} */}
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                spacing={3}
                                style={{ margin: "1rem auto", background: "#e1f5fe" }}
                            >
                                <Grid item md={4}>
                                    <Select
                                        className="input"
                                        id="demo-simple-select-standard"
                                        name="designation"
                                        variant="outlined"
                                        label="Designation"
                                        value={x.designation}
                                        style={{ width: "100%", margin: "0", height: "40px" }}
                                        onChange={(e: any) => handleInputChange(e, index)}
                                        required
                                    // displayEmpty={true}
                                    // value={x.designation !== "" ? undefined : () => "Select Title"}
                                    >
                                        <MenuItem value=""><em>Designation</em></MenuItem>
                                        <MenuItem value="Mr">Mr</MenuItem>
                                        <MenuItem value="Ms">Ms (Mrs/Miss)</MenuItem>
                                        <MenuItem value="other">Others</MenuItem>
                                        {/* <MenuItem value="Baby Boy">Baby Boy</MenuItem>
                      <MenuItem value="Baby Girl">Baby Girl</MenuItem> */}
                                    </Select>
                                </Grid>
                                <Grid item md={4}>
                                <Autocomplete
                                        multiple
                                        id="checkboxes-tags-demo"
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                let packs: any = [];
                                                newValue.map((val: any) => {
                                                    let obj = JSON.parse(
                                                        JSON.stringify(val, null, " ")
                                                    );
                                                    packs.push(obj);
                                                });
                                                let len = packs.length;
                                                handlePackage(index, packs, packs[len - 1]);
                                            }
                                            // setCValue("")
                                        }}
                                        options={packageDetails && packageDetails?.results || []}
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => option?.test_name}
                                        // onInputChange={(event, newInputValue) => {
                                        //     clearTimeout(timer.current);
                                        //     setPincode(newInputValue);
                                        //     if(newInputValue!=="")
                                        //     getPackageDetails(`?pincode=${newInputValue}`)

                                        // }}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.test_name}
                                            </li>
                                        )}
                                        style={{ width: "100%", margin: "0" }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                label="Doctor Name"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        className="input"
                                        name="mobile"
                                        type="text"
                                        label="Mobile Number"
                                        value={mobileNumber}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        style={{ width: "100%", margin: "0" }}
                                        helperText={error} // error message
                                        error={!!error}
                                        onChange={(e) => setMobileNumber(e.target.value)}
                                        required
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <TextField
                                        className="input"
                                        name="alternatemobile"
                                        type="text"
                                        label="Alternate Number"
                                        value={alternateMobileNumber}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        style={{ width: "100%", margin: "0" }}
                                        helperText={error} // error message
                                        error={!!error}
                                        onChange={(e) => setAlternateMobileNumber(e.target.value)}
                                        required
                                    />
                                </Grid>

                                <Grid item md={4}>
                                    <Autocomplete
                                        multiple
                                        id="checkboxes-tags-demo"
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                let packs: any = [];
                                                newValue.map((val: any) => {
                                                    let obj = JSON.parse(
                                                        JSON.stringify(val, null, " ")
                                                    );
                                                    packs.push(obj);
                                                });
                                                let len = packs.length;
                                                handlePackage(index, packs, packs[len - 1]);
                                            }
                                            // setCValue("")
                                        }}
                                        options={packageDetails && packageDetails?.results || []}
                                        disableCloseOnSelect
                                        getOptionLabel={(option: any) => option?.test_name}
                                        // onInputChange={(event, newInputValue) => {
                                        //     clearTimeout(timer.current);
                                        //     setPincode(newInputValue);
                                        //     if(newInputValue!=="")
                                        //     getPackageDetails(`?pincode=${newInputValue}`)

                                        // }}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.test_name}
                                            </li>
                                        )}
                                        style={{ width: "100%", margin: "0" }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                label="Package"
                                            />
                                        )}
                                    />
                                </Grid>
                                {+inputList[0]?.customerAge < 5 && inputList[0]?.customerAge !== "" && <p style={{ textAlign: 'center', width: '100%', color: 'red' }}>Age cannot be less than 5 years.</p>}
                            </Grid>

                        </>
                    );
                })}
            </Grid>
        </Grid>
    )
}
export default AssignDoctors